import { Comparison } from 'helper/products/meteorology';

/**
 * Comparação popular que a Bruna definiu como default do Comparador ao abrir
 * sem preferência salva (#1822, reunião 15/07/2026). O EC46/ECMWF46 vai nos
 * dois modelos — a comparação já vem montada assim do backend.
 */
export const DEFAULT_POPULAR_COMPARISON_NAME = 'Variação da previsão de chuva para o modelo ECMWF46';

/**
 * Escolhe a comparação popular default: casa pelo nome do ECMWF46 e, se ele não
 * estiver na lista (nome mudou no backend), cai para a última comparação
 * disponível. `undefined` quando não há nenhuma comparação popular.
 */
export function defaultPopularComparison(comparisons: Comparison[]): Comparison | undefined {
  if (comparisons.length === 0) return undefined;
  const byName = comparisons.find((c) => c.name === DEFAULT_POPULAR_COMPARISON_NAME);
  return byName ?? comparisons[comparisons.length - 1];
}
